




















































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { convertFileToB64Async, convertUrlToFile } from "@/lib/files/PdfHelper";

@Component({
  components: {
    PdfComponent: () => import("pdfvuer")
  }
})
export default class PdfViewer extends Vue {
  /**
   * The pdf file to display
   */
  @Prop()
  pdf!: File;

  /**
   * previous page
   */
  previousPage = "";

  /**
   * current page
   */
  currentPage = "";

  /**
   * next page
   */
  nextPage = "";

  /**
   * is snackbar visible
   */
  isSnackbar = true;

  /**
   * The PDF as a base64 string
   */
  b64 = "";

  /**
   * The processed pdf file
   */
  processedPdf: any = "";

  /**
   * The currently displayed page
   */
  currPage = 1;

  /**
   * The amount of pages in the pdf
   */
  pageCount = 1;

  /**
   * The loading status of the document
   */
  isDocumentLoading = true;

  /**
   * The rotation factor (..., -2, -1, 0, 1, 2, ...) - can't be a decimal number, as pdf component only supports multiples of 90
   */
  rotateFactor = 0;

  /**
   * How much to scale the pdf
   */
  scaleFactor = 1;

  /**
   * How much to scale the preview
   */
  scaleFactorPreview = this.scaleFactor / 2;

  /**
   * width of canvas
   */
  canvasWidth = 0;

  /**
   * height of canvas
   */
  canvasHeight = 0;

  /**
   * interval to set initial pdf size
   */
  intervalId: number | undefined = 0;

  pdfViewer = import("pdfvuer");

  /**
   * fix for showing wrong page initially
   */
  initial = true;

  /**
   * sets cards background color depending on dark mode
   */
  get setBackgroundColor() {
    return `background-color: ${this.$vuetify.theme.dark ? "#737373" : "#F5F5F5"}`;
  }

  get factor() {
    const canvas = document.getElementsByTagName("canvas")[0];

    if (!canvas) {
      return 1.5;
    }

    return 1920 / this.canvasWidth;
  }

  /**
   * get the number of the next page
   */
  get nextPageNumber() {
    let nextPage = this.currPage + 1;

    if (this.pageCount < nextPage) {
      nextPage = 1;
    }

    return nextPage;
  }

  /**
   * Get the number of the previous page
   */
  get previousPageNumber() {
    let nextPage = this.currPage - 1;

    if (nextPage < 1) {
      nextPage = this.pageCount;
    }

    return nextPage;
  }

  /**
   * Get if display is large
   */
  get mdAndUp() {
    return this.$vuetify.breakpoint.mdAndUp;
  }

  async mounted() {
    this.b64 = await convertFileToB64Async(this.pdf);

    await this.loadPdf();

    this.handleShowPage();

    document.addEventListener("keyup", this.handleKeyDown);
  }

  /**
   * make sure that interval is gone
   */
  beforeDestroy() {
    document.removeEventListener("keyup", this.handleKeyDown);
  }

  get handleGesture() {
    return {
      right: () => this.openPreviousPage(),
      left: () => this.openNextPage()
    };
  }

  /**
   * navigat the pdf using keys
   */
  handleKeyDown(event: any) {
    if (event.key === "ArrowLeft") {
      this.openPreviousPage();
    }

    if (event.key === "ArrowRight") {
      this.openNextPage();
    }

    if (event.key === "Enter" || event.key === " ") {
      this.exportPDF();
    }
  }

  /**
   * processes the pdf and sets important meta info
   */
  async loadPdf() {
    this.processedPdf = (await this.pdfViewer).createLoadingTask(this.b64);
    this.pageCount = (await this.processedPdf).numPages;
  }

  /**
   * Opens next page (or first when on last)
   */
  openNextPage() {
    if (this.pageCount === 1) return;

    this.currPage = this.nextPageNumber;

    this.isDocumentLoading = true;
    this.handleShowPage();
  }

  /**
   * opens previous page (or last when on first)
   */
  openPreviousPage() {
    if (this.pageCount === 1) return;

    this.currPage = this.previousPageNumber;

    this.handleShowPage();
  }

  /**
   * opens the next page with a little timeout
   * Timeout is important because the canvas needs time to get ready, but theres no way to find out when it is ready
   * so we wait a little bit and then try to show the page
   */
  handleShowPage() {
    this.isDocumentLoading = true;
    this.currentPage = "";
    this.previousPage = "";
    this.nextPage = "";
    window.setTimeout(() => (this.intervalId = window.setInterval(this.showPdfAsImage, 10)), 500);
  }

  /**
   * converts current page to image
   */
  showPdfAsImage() {
    let done = true;
    const canvasses = document.getElementsByTagName("canvas");
    const currentPage = canvasses[0];
    const previousPage = canvasses[1];
    const nextPage = canvasses[2];

    if (currentPage) {
      this.currentPage = currentPage.toDataURL();
    } else {
      done = false;
    }

    if (previousPage) {
      this.previousPage = previousPage.toDataURL();
    } else {
      done = false;
    }

    if (nextPage) {
      this.nextPage = nextPage.toDataURL();
    } else {
      done = false;
    }

    if (done) {
      this.isDocumentLoading = false;
      window.clearInterval(this.intervalId);
    }
  }

  /**
   * converts current page to image
   */
  async exportPDF() {
    if (this.currentPage) {
      const file = await convertUrlToFile(this.currentPage, `${this.pdf.name}_${this.currPage}.jpg`, "image/jpg");
      this.$emit("onImageExport", file);
    }
  }
}
